<template>
  <!-- 面包屑 -->
  <el-breadcrumb style="margin-bottom:20px" :separator="separator" :separator-class="separatorClass?separatorClass:''">
    <template v-for="(item,index) in data">
      <el-breadcrumb-item :key="index">
        <i :class="icon" v-if="index==0"></i>
        <span :style="index==0?'color: #C1C3CF;':''">{{item}}</span>
      </el-breadcrumb-item>
    </template>
  </el-breadcrumb>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  props: {
    // 头部图标
    icon: {
      type: String,
      default: 'el-icon-location'
    },
    // 图标分隔符
    separator: {
      type: String,
      default: '/'
    },
    // 分隔符
    separatorClass: {
      type: String,
      default: null
    },
    data: {
      type: Array,
      default: []
    }

  },
  created () { },
  watch: {

  },
  methods: {

  },
  mounted () {

  }
}
</script>

<style scoped="">
</style>



// WEBPACK FOOTER //
// src/components/parts/h-breadcrumb.vue